import { Box, Spacer, TextNew } from '@jfs/ui-new'
import { ReactElement, useEffect, useState } from 'react'
import { staticStrings } from '../../data/static/strings'
import Calendar, { CalendarTypes } from '../Calendar'
import { styles } from './styles'

export interface CalendarViewModalProps {
  onDateSelection: (firstDate: Date, secondDate?: Date) => void
  dateRange: string
  type: CalendarTypes
  onCancel: () => void
  defaultMinDate?: Date
  defaultMaxDate?: Date
  maxDuration?: number
  scrollToCurrentDate?: boolean
  sendError?: any
}

const CalendarViewModal = ({
  onDateSelection,
  dateRange,
  type,
  onCancel,
  defaultMinDate,
  defaultMaxDate,
  maxDuration,
  scrollToCurrentDate,
  sendError,
}: CalendarViewModalProps): ReactElement => {
  const [minDate, setMinDate] = useState<Date>()
  const [maxDate, setMaxDate] = useState<Date>()
  useEffect(() => {
    setMinDate(defaultMinDate)
    setMaxDate(defaultMaxDate)
  }, [defaultMaxDate, defaultMinDate])

  return (
    <Box {...styles.calendarContainer}>
      <Spacer size={16} />
      <Box {...styles.selectionContiner}>
        <TextNew type={'body12'}>{staticStrings.dateRange}</TextNew>
        <Spacer size={4} />
        <TextNew type={'body14'} fontWeight={'800'}>
          {dateRange}
        </TextNew>
      </Box>
      <Box {...styles.scrollVIewStyle}>
        <Calendar
          ID="Custom-Date"
          type={type}
          defaultMinDate={minDate}
          holidayList={[]}
          onDateSelected={onDateSelection}
          onCancel={onCancel}
          defaultMaxDate={maxDate}
          maxDuration={maxDuration}
          scrollToCurrentDate={scrollToCurrentDate}
          sendError={sendError}
        />
      </Box>
    </Box>
  )
}

export default CalendarViewModal
